"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var admin_instructor_add_location_html_1 = __importDefault(require("./admin-instructor-add-location.html"));
var admin_instructor_add_location_controller_1 = __importDefault(require("./admin-instructor-add-location.controller"));
function getSchoolCampuses(LocationsModel) {
    return LocationsModel.getLocations().then(function (response) {
        return response;
    });
}
getSchoolCampuses.$inject = ["LocationsModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.instructors.addlocation", {
        url: "/:instructorId/add-location",
        controller: admin_instructor_add_location_controller_1.default,
        controllerAs: "vm",
        template: admin_instructor_add_location_html_1.default,
        resolve: {
            campuses: getSchoolCampuses,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.dashboard.instructors.addlocation", [])
    .config(config)
    .controller("AdminInstructorAddLocationController", admin_instructor_add_location_controller_1.default);
